import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { UserModel } from './user.model';

export const onGetUserByPhoneNumber = (phone_number: string): Promise<UserModel[]> => {
  return axiosInstance.get(http_config.BASE_URL + '/users?role_code=444&search=' + phone_number);
};

export const onGetTeacherBySearch = (value: string): Promise<UserModel[]> => {
  return axiosInstance.get(http_config.BASE_URL + '/users?role_code=333&search=' + value);
};

export const onGetUsers = (): Promise<UserModel[]> => {
  return axiosInstance.get(http_config.BASE_URL + '/users');
};
